import React from 'react';
import { Hearts } from 'react-loader-spinner';

const LoaderOverlay = ({ loading }) => {
  return (
    <React.Fragment>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // semi-transparent black overlay
            zIndex: 9999, // ensures the overlay is on top of everything
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
            {/* <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: '#fff',
                textAlign: 'center',
                zIndex: 10000, // ensures the loader and text are above the overlay
              }}
            >
              Loading...
            </div> */}
                <div id="preloader">
                <div id="container" className="container-preloader">
                    <div className="animation-preloader">
                    {/* <div class="spinner"></div> */}
                    {/* <div className="txt-loading">
                        <span preloader-text="c" className="characters">C</span>
                        <span preloader-text="A" className="characters">A</span>
                        <span preloader-text="S" className="characters">S</span>
                        <span preloader-text="H" className="characters">H</span>
                        <span preloader-text="E" className="characters">E</span>
                        <span preloader-text="E" className="characters">E</span>
                    </div> */}
                    </div>
                    {/* <div class="loader-section section-left"></div>
                    <div class="loader-section section-right"></div> */}
                </div>
                </div>
          <Hearts
            visible={true}
            height={80}
            width={80}
            ariaLabel="discuss-loading"
            wrapperStyle={{}}
            wrapperClass="discuss-wrapper"
            color="#ff6dc0"
      
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default LoaderOverlay;